import { ApplicationConfig, isDevMode, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withPreloading } from '@angular/router';

import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { provideQuillConfig } from 'ngx-quill/config';

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_NATIVE_DATE_FORMATS, provideNativeDateAdapter } from '@angular/material/core'; // ### jackie add
import { provideHttpClient, withFetch } from '@angular/common/http';
import { CustomPreloadingStrategy } from 'jk-service';
import { CustomDateAdapter } from 'jk-service';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),// 🔥 新增 zoneless 支援
    provideRouter(routes, withPreloading(CustomPreloadingStrategy)),
    //provideAnimationsAsync(),
    provideNativeDateAdapter(),// ### jackie add
    { provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE] }, // ### jackie add
    { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'zh-TW' },

    provideQuillConfig({ // ### jackie add
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'link'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['clean'],
        ],
      }
    }),
    provideHttpClient(withFetch()), // 添加 withFetch() 以支援 keepalive 選項
    provideServiceWorker('ngsw-worker.js', { // ### jackie add
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    // Lazy loading services
    CustomPreloadingStrategy,
  ]
};

